import React, { useState } from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import { Placement } from 'react-bootstrap/esm/types';
import Button from '../../../components/Button';

export type FilterPopoverProps = React.PropsWithChildren<{
  placement?: Placement;
  popoverBody: React.ReactNode;
  filterDisabled?: boolean;
  onFilter?: () => void;
  onReset?: () => void;
}>;

const FilerPopover = ({
  placement = 'bottom-end',
  children,
  popoverBody,
  filterDisabled,
  onFilter,
  onReset,
}: FilterPopoverProps) => {
  const [show, setShow] = useState(false);
  const handleToggle = () => {
    setShow((prev) => !prev);
  };

  const handleOnFilter = () => {
    setShow((prev) => !prev);
    onFilter && onFilter();
  };

  const filterBody = (
    <Popover bsPrefix={'popover filter'}>
      <Popover.Body>
        {popoverBody}
        <section className={'mt-7 d-flex justify-content-between'}>
          <Button onClick={onReset} variant={'primary-outline'}>
            {'Reset'}
          </Button>
          <Button disabled={filterDisabled} onClick={handleOnFilter}>
            {'Filter'}
          </Button>
        </section>
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger={'click'}
      placement={placement}
      overlay={filterBody}
      show={show}
      onToggle={handleToggle}
      rootClose={show}
    >
      <div className={'d-flex'}>{children}</div>
    </OverlayTrigger>
  );
};

export default FilerPopover;
